import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const OurCommunity = () => {
  return (
    <div>
      <Helmet>
        <title>Our Community | Idexcel</title>
        <meta
        content="idexcel community, corporate social responsibility team"
        name="keywords"
        />
        <meta
        content="Idexcel has a committed Corporate Social Responsibility team. Our top two priorities are supporting Science Technology Engineering and Math (STEM) programs and Veteran Groups."
        name="description"
        />
      </Helmet>
       <Container fluid className="our-community-banner-container p-0">
             <section className="our-community-banner-section"></section>
           </Container>
      <Container className="px-2 px-lg-3 px-xxl-5 pb-xl-5">
        <section style={{textAlign: "justify"}}>
          <Row className="p-0 m-0 px-0 px-lg-4 pt-md-3 pt-4">
            <h2 className="text-center mb-4 section-title">
              Our <span className="textgrad"> Community </span>
            </h2>
            <p >
              Idexcel has a committed Corporate Social Responsibility team. Our
              top two priorities are supporting Science Technology Engineering
              and Math (STEM) programs and Veteran Groups.
            </p>
            <p >
              We are committed to supporting programs, events and campaigns that
              focus on student achievement, teacher development, and gender and
              ethnic diversity.
            </p>
          </Row>
          <Row className="m-0 p-0 px-0 px-lg-4 points pb-1">
            <h1 className="fs-4 px-4 px-lg-2 px-md-4 fw-semibold text-left mt-2 mb-3">
              Brief Account of some of these programs:
            </h1>
            <div className="Brief-Account-text px-0">
              <div className="points-list m-0 d-flex  align-items-start">
                <FontAwesomeIcon
                  className="mt-1 mt-xl-2 px-xl-2"
                  icon={faAngleRight}
                />
                <p className="m-0 mb-3 px-2">
                  Idexcel recently launched a K-12 company matching program for
                  employees by partnering with DonorsChoose.org to support STEM
                  education in its local communities.
                </p>
              </div>
              <div className="points-list m-0 d-flex  align-items-start">
                <FontAwesomeIcon
                  className="mt-1 mt-xl-2 px-xl-2"
                  icon={faAngleRight}
                />
                <p className="m-0 mb-3 px-2">
                  Through this STEM education outreach initiative, Idexcel
                  provides numerous opportunities for its employees to interact
                  with and inspire the next generation of engineers and
                  technologists by serving as local school advisors,
                  extracurricular activity mentors and career role models for
                  students in communities where we live and work.
                </p>
              </div>
              <div className="points-list m-0 d-flex align-items-start">
                <FontAwesomeIcon
                  className="mt-1 mt-xl-2 px-xl-2"
                  icon={faAngleRight}
                />
                <p className="m-0 mb-3 px-2">
                  Idexcel has developed a pilot program that connects Idexcel
                  volunteers with girls aged 9-12 years to strengthen their
                  interests and confidence in pursuing STEM education and
                  careers.
                </p>
              </div>
            </div>
            <p className="m-0 my-4 px-lg-1">
              Idexcel is deeply committed to providing employment opportunities
              for Veterans and helping them to enter the workforce.
            </p>
            <div className="Brief-Account-text px-0">
              <div className="points-list m-0  d-flex align-items-start">
                <FontAwesomeIcon
                  className="mt-1 mt-xl-2 px-xl-2"
                  icon={faAngleRight}
                />
                <p className="m-0 mb-3 px-2">
                  Idexcel has created a working-group of its employees with
                  military backgrounds and those who are interested in veterans’
                  issues. This working group provides professional development
                  opportunities and mentoring support to Veterans in our
                  communities.
                </p>
              </div>
              <div className="points-list m-0 d-flex align-items-start">
                <FontAwesomeIcon
                  className="mt-1 mt-xl-2 px-xl-2"
                  icon={faAngleRight}
                />
                <p className="m-0 mb-3 px-2">
                  Idexcel has contributed financially to the Wounded Warrior
                  Program and the USO
                </p>
              </div>
              <div className="points-list m-0 d-flex  align-items-start">
                <FontAwesomeIcon
                  className="mt-1 mt-xl-2 px-xl-2"
                  icon={faAngleRight}
                />
                <p className="m-0 mb-3 px-2">
                  Supported the Wreaths Across America Program.
                </p>
              </div>
              <div className="points-list m-0 d-flex  align-items-start">
                <FontAwesomeIcon
                  className="mt-1 mt-xl-2  px-xl-2"
                  icon={faAngleRight}
                />
                <p className="m-0 mb-3 px-2">    
                  In 2018, Idexcel pledged to increase its Veteran hires by 50%
                </p>
              </div>
            </div>
          </Row>
        </section>
      </Container>
    </div>
  );
};

export default OurCommunity;
